import { ApprovalObjectInfo } from './approval-object-info';
import { Deserialize, inheritSerialization } from 'cerialize';
import { ProviderFeeSchedule } from './provider-fee-schedule';

@inheritSerialization(ApprovalObjectInfo)
export class ProviderFeeScheduleApprovalObjectInfo extends ApprovalObjectInfo {
  get providerFeeSchedule(): ProviderFeeSchedule {
    return Deserialize(this.object, ProviderFeeSchedule);
  }
}
